import { ListItem, ListItemText } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

import useStyles from './styles';

type SideNavItemProps = {
  currentPathName?: string;
  href?: string;
  id?: string;
  isDisabled?: boolean;
  isLink?: boolean;
  label: string;
  customComponent?: React.ReactNode;
};

type ListItemProps = {
  component?: unknown;
  disabled?: boolean;
  href?: string;
  to?: string;
};

export default function SideNavItem({
  isLink,
  href,
  label,
  isDisabled,
  currentPathName,
  customComponent,
}: SideNavItemProps): JSX.Element {
  const classes = useStyles();
  const listItemProps: ListItemProps = {
    component: customComponent ? 'p' : 'a',
    disabled: isDisabled,
    href,
  };
  const component = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref: React.Ref<HTMLAnchorElement>) => (
        <Link ref={ref} to={href ?? ''} {...linkProps} />
      )),
    [href],
  );
  if (isLink) {
    listItemProps.component = component;
    delete listItemProps.href;
    listItemProps.to = href;
  }

  const selected = href === currentPathName;

  return (
    <ListItem
      {...listItemProps}
      button
      classes={{ root: classes.root, selected: classes.selected }}
      selected={selected}
    >
      {customComponent ?? <ListItemText classes={{ primary: classes.item }} primary={label} />}
    </ListItem>
  );
}

SideNavItem.defaultProps = {
  isDisabled: false,
  isLink: false,
};
